export default __webpack_public_path__ + "static/media/Pic15.d3fb2952.jpg";